import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.es'

export default createLendingBundle(whitepaper)
